import { FormLabel, FormControl, FormControlLabel } from 'material-ui/Form';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MuRadio, { RadioGroup } from 'material-ui/Radio';
import styles from '../../constants/styles';
import { withStyles } from 'material-ui/styles';
import camelCase from 'lodash/camelCase';
import capitalize from 'lodash/capitalize';

export class Radio extends Component {
  render() {
    const { classes, required, label, value, onChange, options } = this.props;
    const name = camelCase(label);

    return (
      <FormControl component="fieldset" required={ required }>
        <FormLabel component="legend">{ label }</FormLabel>
        <RadioGroup
          aria-label={ label }
          name={ name }
          className={ classes.group }
          value={ value }
          onChange={ onChange }
        >
        {
          options.map(option =>
            <FormControlLabel
              key={ option }
              value={ option }
              control={ <MuRadio /> }
              label={ capitalize(option) }
              data-test="radio-button"
            />
          )
        }
        </RadioGroup>
      </FormControl>
    );
  }
}

Radio.propTypes = {
  classes:  PropTypes.object.isRequired,
  label:    PropTypes.string.isRequired,
  value:    PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  options:  PropTypes.array,
}

export default withStyles(styles)(Radio);



// WEBPACK FOOTER //
// ./src/components/common/Radio.js